// axios
import axios from 'axios'
import store from './store/store'

// const baseURL = 'https://copywriters.avada-media-dev1.od.ua/';
// const baseURL = 'https://datei.akadhilfe24.de/';
// const baseURL = 'http://copywriting-backend.loc/';
const baseURL = 'https://backend-ai.klausurencoach.de/';
// const baseURL = 'https://backend.test.klausurencoach.de/';

let axiosInstance = axios.create({
	baseURL,
	headers: {
		Authorization: "Bearer "+ store.state.auth.token,
		'Content-Type': 'application/json',
		'Access-Control-Allow-Origin': baseURL
	},
});

axiosInstance.interceptors.request.use(function(config) {
	// if(config.method === 'GET' || config.method === 'get') {
	let param = `language=${store.state.locale}`;

	if(config.url.indexOf('?') === -1) {
		config.url += '?' + param;
	} else {
		config.url += '&' + param;
	}
	// }

	return config;
})

export default axiosInstance;

